import { render, staticRenderFns } from "./UtilityDetailPubCurrent.vue?vue&type=template&id=73979bdf&scoped=true&"
import script from "./UtilityDetailPubCurrent.vue?vue&type=script&lang=js&"
export * from "./UtilityDetailPubCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73979bdf",
  null
  
)

export default component.exports